import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import type { SelectProps } from '@hhgtech/hhg-components/mantine'
import { Text } from '@hhgtech/hhg-components/mantine'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
import { ModalBaseStylesNames, Styles } from '@mantine/core'

export const StyledDueDateCalculatorCardBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  isolation: isolate;
  background: ${theme?.colors.white};
  border: 1px solid ${theme?.colors.pink200};
  border-radius: 12px;
  width: 100%;
  .card-header {
    position: relative;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 8px 48px;
    background-color: ${theme?.colors?.pink100};
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    .left-arrow {
      left: 1rem;
    }
    .right-arrow {
      right: 1rem;
    }
  }
  ${MediaQueries.mbDown} {
    /* padding: 16px; */
  }
`

const fadeIn = keyframes`
  from {
  opacity: 0;
  }

  to {
    opacity: 1;
  }
`

export const StyledDueDateCalculatorCardBodyDetails = styled.div`
  /* margin-top: 24px; */
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 40px;
  width: 100%;
  opacity: 0;
  min-height: 340px;
  animation: ${fadeIn} 300ms ease-in-out forwards;

  ${MediaQueries.mbDown} {
    width: 100%;
    flex-direction: column;
    gap: 8px;
  }
  ${MediaQueries.mbUp} {
    padding: 24px;
  }
  &[data-is-over-pregnancy='true'] {
    text-align: center;
    flex-direction: column;
    gap: 24px;
    min-height: 356px;

    p {
      white-space: pre-line;
    }
  }
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    max-width: 580px;

    ${MediaQueries.mbDown} {
      width: 100%;
      flex-direction: column;
      padding-left: 24px;
      padding-right: 24px;

      & > button {
        width: 100%;
      }
    }
  }
  .baby-img-by-week {
    width: 180px;
    height: 180px;
  }
`

export const StyledBabyWeekHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.neutral100};
  background-color: ${theme.colors.neutral50};

  .week-image {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    gap: 10px;
    width: 48px;
    min-width: 48px;
    height: 48px;
    background: #ffffff;

    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06),
      0px 0px 1px rgba(0, 0, 0, 0.04);
    border-radius: 64px;
    img {
      width: 32px;
      height: 32px;
    }
  }
`

export const StyledBabyWeekDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  /* max-width: 320px; */
  /* width: 100%; */

  .week-detail {
    height: 100%;
    background: #ffffff;

    a {
      /* Prevent user click to the link generated CMS. There is another place to have CTA Link already and want to focus on it */
      pointer-events: none !important;
    }
  }
  ${MediaQueries.mbUp} {
    padding-top: 36px;
    padding-bottom: 36px;
  }
  ${MediaQueries.mbDown} {
    max-width: initial;
  }
`

export const StyledToolRecommendation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;

  .due-date-reached-image {
    max-width: 120px;
    margin-bottom: 24px;
    object-fit: contain;
    ${MediaQueries.mbUp} {
      max-width: 160px;
      margin-bottom: 8px;
    }
  }
`

export const StyledWeekOption = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  &[data-selected='true'] {
    &,
    &:hover {
      background-color: ${theme?.colors.primary100};
    }
  }

  // applies styles to hovered item (with mouse or keyboard)
  &:hover {
    background-color: ${theme?.colors.primary50};
  }
`

export const StyledSelectedWeek = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  pointer-events: none;

  &[data-absolute='true'] {
    gap: 9px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const EmotionSelectStyles = {
  root: {
    width: '100%',
    textAlign: 'center',
  },
  dropdown: {
    width: '100% !important',
    border: `1px solid ${theme?.colors.neutral100}`,
    minWidth: '270px',
    maxWidth: '370px',
    padding: '8px 16px 8px 0px',
    boxShadow:
      '0px 10px 16px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    borderRadius: '8px',
  },
  wrapper: {
    opacity: 0,
    minHeight: 32,
  },
  input: {
    width: '100%',
    textAlign: 'center',
    minWidth: '100px',
    fontSize: 'inherit',
    lineHeight: '60px',
    overflow: 'auto',
    color: 'inherit',
    border: 0,
    '&:hover, &:focus': {
      border: 0,
      boxShadow: 'none',
    },
  },
  item: {
    // applies styles to selected item
    '&[data-selected]': {
      '&, &:hover': {
        backgroundColor: theme?.colors.primary100,
      },
    },

    // applies styles to hovered item (with mouse or keyboard)
    '&[data-hovered]': {
      backgroundColor: theme?.colors.primary50,
    },
  },
} as SelectProps['styles']

export const modalStyles: Styles<ModalBaseStylesNames> = (theme) => ({
  body: {
    padding: 0,
  },
  content: {
    position: 'relative',
    borderRadius: 6,
    padding: '32px 16px 24px 16px',
    [theme.fn.largerThan('sm')]: {
      padding: '48px 32px 64px 32px',
      maxWidth: '407px',
    },
  },
  header: { display: 'none' },
})
